/* eslint-disable @typescript-eslint/no-deprecated */

import * as React from 'react'
import styled, { useTheme } from 'styled-components'
import { SmallHeading } from '../Typography'
import { buildColSpans, GridCardContainer } from './GridCard'

interface Props {
  title?: string | React.ReactNode
  backgroundColor?: string
  onClick?: () => void
}

export const MiniGridCard: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  backgroundColor,
  onClick,
  children,
}) => {
  const { colors } = useTheme()
  const background = backgroundColor ?? colors.white
  return (
    <MiniGridCardContainer
      columnSpans={buildColSpans(2)}
      backgroundColor={background}
      clickable={onClick != null}
      stretchY
    >
      <MiniGridCardContentContainer role="button" onClick={onClick} clickable={onClick != null}>
        {title && <MiniCardGridHeading>{title}</MiniCardGridHeading>}
        <MiniCardGridBody>{children}</MiniCardGridBody>
      </MiniGridCardContentContainer>
    </MiniGridCardContainer>
  )
}

const MiniGridCardContainer = styled(GridCardContainer)`
  height: 24rem;
  overflow-y: hidden;
`

const MiniGridCardContentContainer = styled.div<{ clickable: boolean }>`
  ${({ clickable }) => (clickable ? 'cursor: pointer;' : '')}
`

const MiniCardGridHeading = styled(SmallHeading)`
  font-size: 2rem;
  margin: 2rem 2rem 0 2rem;
  min-height: 3rem;
`

const MiniCardGridBody = styled.div`
  height: 100%;
  margin: 2rem;
`
